export default function phoneNormaliser(input) {
  return input.replaceAll(/\s/g, '').replace(/^\+61/, '0')
}
